import { Badge } from 'reactstrap'

/**
 * Get columns for Lesson For Grade List DataTable
 * @param {string} studentId - Student ID
 * @param {boolean} isStudent - Whether the user is a student
 * @param {string} role - User role (student911/instructor)
 * @param {string} layout - Layout type
 * @returns {array} Column definitions for DataTable
 */
export const getLessonForGradeColumns = (studentId, isStudent, role, layout, handleEdit) => [
	{
		name: 'ID',
		selector: (row) => row.id,
		sortable: true,
		width: '10%'
	},
	{
		name: 'Department',
		selector: (row) => row.pname,
		sortable: true,
		width: '25%'
	},
	{
		name: 'Course',
		selector: (row) => row.lessonName,
		sortable: true,
		width: '30%'
	},
	{
		name: 'Status',
		selector: (row) => row.isActive,
		sortable: true,
		width: '15%',
		center: true,
		cell: (row) => (
			<Badge color={row.isActive ? 'success' : 'secondary'} className="px-3 py-2">
				{row.isActive ? 'Active' : 'Inactive'}
			</Badge>
		)
	},
	{
		name: 'Actions',
		width: '20%',
		center: true,
		cell: (row) => (
			<button onClick={() => handleEdit(row)} className="btn btn-success btn-sm">
				<i className="fa fa-edit me-1"></i>
			</button>
		)
	}
]
